export default "__VITE_ASSET__CJkPSbHF__"